import Vue from 'vue';
import api from '../api';
import { isDev } from '../util/dev';

Vue.mixin({
	mounted() {
		if (!window.Cypress && !isDev) return;
		let name = this.$options.name;
		if (!name) return;
		name = name.toLowerCase();
		if (!window.testing) window.testing = {};
		if (!window.testing.components) window.testing.components = {};
		if (Array.isArray(window.testing.components[name])) {
			window.testing.components[name].push(this);
		} else {
			window.testing.components[name] = [this];
		}
		window.testing.api = api;
	},
	beforeDestroy() {
		if (!window.Cypress && !isDev) return;
		let name = this.$options.name;
		if (!name) return;
		name = name.toLowerCase();
		window.testing.components[name] = window.testing.components[name].filter((e) => e !== this);
	},
});
